import { Component, type OnDestroy, type OnInit, inject } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { IconSetService } from "@coreui/icons-angular";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { HotkeysService } from "@ngneat/hotkeys";
import { pdfDefaultOptions } from "ngx-extended-pdf-viewer";
import { FaviconService } from "./core/services/favicon.service";
import { HotkeyHelpModalComponent } from "./hotkey/components/hotkey-help-modal.component";
import { iconSubset } from "./icons/icon-subset";
import { PendoService } from "./shared/pendo/pendo.service";
import { SearchBarService } from "./shared/search-bar/search-bar.service";

@Component({
    selector: "body",
    template: "<app-dashboard></app-dashboard>",
    standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
    private readonly router = inject(Router);
    private readonly searchBarService = inject(SearchBarService);
    private readonly modalService = inject(NgbModal);
    private readonly hotkeys = inject(HotkeysService);
    private readonly iconSetService = inject(IconSetService);
    private readonly faviconService = inject(FaviconService);
    private readonly pendoService = inject(PendoService);

    constructor() {
        // // attempt to fix missing data on some PDFs, see #1273
        // pdfDefaultOptions.renderForms = false;

        // disabling JS in PDFs, see #1416
        pdfDefaultOptions.enableScripting = false;

        this.iconSetService.icons = { ...iconSubset };
    }

    ngOnInit(): void {
        this.faviconService.init();
        this.pendoService.registerPendo();

        this.hotkeys.registerHelpModal(() =>
            this.modalService.open(HotkeyHelpModalComponent),
        );

        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            this.searchBarService.loadFullPath();
            window.scrollTo(0, 0);
        });
    }

    ngOnDestroy(): void {
        this.pendoService.unregisterPendo();
    }
}
